import ModelType from '../../Model/ModelType';
import T from '../../../localization/LocalizationKeys';
import NodeDataSource from './NodeDataSource';
import PropertyFunction from './util/PropertyFunction';
import _ from 'lodash';

const PropertyDataSource =
  ({
    nodes: nodesFromDatasource,
    properties = []
    // reloadTrigger
  }) => {
    return PropertyFunction({ nodes: nodesFromDatasource, properties });
  };

PropertyDataSource.models = [
  ...NodeDataSource.models,
  {
    path: 'properties',
    type: ModelType.PROPERTIES,
    label: T.common.properties
  }
];

PropertyDataSource.getUsedSystemModels = (data) => {
  return _.uniq(_.reduce(data.properties, (result, property) => [...result, property.modelId], []));
};

PropertyDataSource.getUsedAssets = (data) => {
  return NodeDataSource.getUsedAssets(data);
};

export default PropertyDataSource;
